module.exports = __webpack_public_path__ + "img/arrow_left.ae1aaf1f.svg";